import { decryptAES } from 'utils/generalUtils';
import { v4 as uuidv4 } from 'uuid';

export const applicationType = "MYSELFCERT";

export const applicationLogoPaths = {
    MYSELFCERT: {
        light: "/static/logo/logogse.png",
        dark: "/static/logo/logogselh.png",
        favicon: "/faviconGSE.svg",
    },
    LETMICERT: {
        light: "/static/logo/logo_letmi_dark.svg",
        dark: "/static/logo/logo_letmi_light.svg",
        faviconLight: "/static/logo/icon_letmi_light.svg",
        faviconDark: "/static/logo/icon_letmi_dark.svg",
    }
};

export const getApplicationLogoPath = (isLightMode = true) => {
    const logoPaths = applicationLogoPaths[applicationType] ?? applicationLogoPaths.MYSELFCERT;
    return isLightMode ? logoPaths.light : logoPaths.dark;
};

export const getApplicationFaviconPath = (isLightMode = true) => {
    const logoPaths = applicationLogoPaths[applicationType] ?? applicationLogoPaths.MYSELFCERT;
    return isLightMode
        ? logoPaths.faviconLight ?? logoPaths.favicon
        : logoPaths.faviconDark ?? logoPaths.favicon;
};

export const sizeButtonModalContained = { height: 42, width: 168, fontSize: "13px", fontWeight: 600 }

export const sizeButtonModalOutlined = { height: 42, width: 168, fontSize: "13px", fontWeight: 500 }

export const maxSizeFileRevoke = 4000000

export const configurationFileAdditinal = {
    maxSize: 8000000,
    typeFile: ['.pdf', 'jpeg', '.jpg', '.png']
}

export const configFileIssuance = {
    maxSize: 8,
    typeFile: ['p12']
}
//Variables para la validacion de archivos .csr en asignacion de solicitudes

export const configFileAssignmentCsr = {
    maxSize: 8,
    typeFile: ['csr']
}

export const configFileAssignmentCsrStyles = {
    errorColor: "#ff316f",
    errorIconColor: "#d8275d",
    errorBackgroundColor: "#FDECEC"
}

export const xroadFlowProductsConfigurationRequest = {
    configurationCode: "XroadFlow",
    configurationKey: "EnableProducts",
    filter: ""
}

export const xroadFlowWarningResponseCodes = ["CR910", "CR911"]

// true: cierra el modal de asignacion y deja visible solo la alerta.
// false: mantiene el modal de asignacion abierto detras de la alerta.
export const xroadCloseAssignmentModalOnWarning = false

//Variables para la validacion de archivos .csr en asignacion de solicitudes

export const typesDocsToValidateStatus = ["VIC", "VIA", "VIM"]
export const docTypesToNoValidateFingerPrintCode = ["C.E", "Nit", "Pas", "PEP", "PPT", "R.C", "T.I"]
export const specificDocumentTypes = ["TIP", "ACG", "SOP", "SPV", "VIC", "VIA", "MUI", "RUE", "RVK", "VIM"]
export const matchPercentageANINamesValidation = 0
export const matchPercentageDACNamesValidation = 0

export const typesIdentityDocumentsAllowed = "CC,DNI,CE"

export const signingCredentialValidations = { characters: 'a-zA-Z0-9', length: 25 }
export const credentialValidations = {
    characters: "a-zA-Z0-9!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~\\\\",
    length: 25,
};

export const identityValidationIds = [1, 3]
export const tableSizes = { pageSizeUsers: 20, pageSizeRoles: 20, pageSizeUbications: 20, pageSizeListRevoke: 7, pageSizeConfigs: 20, pageSizeRequestManagement: 20, pageSizeLogistic: 20, pageSizeMyself: 100, pageSizeELectronics: 20, pageSizeClientSection: 10, pageSizeLogisticQueue: 20 }

export const userListApiTake = 100;

export const documentaryValidationIds = [2, 3]
export const managementDateElectronics = { maxDate: 30, initialRangeDate: 2 }
export const managementDateRequestManagement = { maxDate: 90, initialRangeDate: 1 }
export const startDateAgreements = "2025/01/01" // YYYY/MM/DD
export const managementDateAgreements = { maxDate: 90, initialRangeDate: 7 }
export const managementDateLogistic = { maxDate: 90, initialRangeDate: 7, initialRangeDateLogistic: 30 }
export const documentaryValidationConfiguration = {
    appovedAllButton: true
}
export const validationsConfigurations = {
    nameRolMaxLength: 255,
    describeRolMaxLength: 100,
    describeRolMinLength: 3,
    nameUserMaxLength: 255,
    lastNameUserMaxLength: 300,
    documentNumberUserMaxLength: 300,
    emailUserMaxLength: 300,
    emailUserMinLength: 3,
    codeMaxLength: 8,
    obervationMaxLength: 300,
    nameLocationMaxLength: 100,
    isoCodeMaxLength: 2,
    daneCodeMaxLength: 3,
    namesMaxLength: 100,
    vehiculeIdMaxLength: 6,
    firstNameMaxLength: 50,
    secondNameMaxLength: 50,
    firstLastNameMaxLength: 50,
    secondLastNameMaxLength: 50,
    documentNumberMaxLength: 15,
    emailMaxLength: 50,
    firstNameMinLength: 2,
    secondNameMinLength: 2,
    firstLastNameMinLength: 2,
    secondLastNameMinLength: 2,
    documentNumberMinLength: 5,
    emailMinLength: 5,
    addressMaxLength: 200,
    addressMinLength: 5,
}
export const termsAndConditionsSuscription = {
    validateTermsAndConditions: true,
}

export const consultResult = [
    '66ec4103ed0a889373d91e33',
    '66ec4773ed0a889373d9c177',
    '66ed7e90ce0503955c072f8a',
    '66edcec6ed0a889373f99227',
    '66e47f52ed0a889373432fe9',
    '6708729fed0a889373046a2e'
]

export const idStatusAPL = '66ec4773ed0a889373d9c177'

export const idStatusVAL = '66ec4103ed0a889373d91e33'

export const idStatusAPR = '66ed7e90ce0503955c072f8a'

export const idStatusRCZ = '66edcec6ed0a889373f99227'

export const idStatusRAD = '66e47f52ed0a889373432fe9'

export const idStatusEMC = '6708729fed0a889373046a2e'

export const limitCharacters = 500

export const defaultDeliveryCountry = '44' //Corresponde a Colombia como pais por defecto para la entrega de token

export const longthTooltips = {
    userLongthTooltip: 30,
    observationLongthTooltip: 120
}

export const applicationIdLicense = "91d58ad9-1ae5-4e2d-9644-059f91886f56"

export const requestByCriptBM = {
    nonce: uuidv4(),
    timestamp: formatDate(new Date()), // Formato YYYY/MM/DD
};

export function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
};

export const createDataByPrint = (dataGeneral) => {
    const { requestByCriptBMCurrent, rowCurrent } = dataGeneral;

    let generalData = {
        "deviceName": "Printer.EpsonLX350.Core",
        "versionInfo": {
            FileVersion: "1.0.0.0",
            IsLastVersion: true
        },
        "nonce": requestByCriptBMCurrent.nonce, //GUID
        "timestamp": requestByCriptBMCurrent.timestamp, //AAAA/MM/DD
        "data": {
            "saveLog": true,
            "processId": uuidv4(),
            "timeOut": 5, // MIN: 5 MAX 30 
            "Name": rowCurrent.subscriberName,
            "Pin": decryptAES(rowCurrent.encryptionPin),
            "Serial": rowCurrent.serialToken,
            "NickName": rowCurrent.subscriberName,
            "PrinterName": "EPSON LX-350 ESC/P"
        }
    }
    return generalData;
}

export const assignLICPrefix = "GSE";


export const listDocumentsApplyByIconBagde = ["DNI", "FRD", "RVD", "SFD"]
export const listDocumentsApplyByIconAssignment = ["CYC"]
export const listDocumentsApplyByIconContact = ["CLB"]

export const documentsImages = ['jpeg', 'jpg', 'png']
export const structureServiceId = '67a4efbd78bc941ef2ebd832';

export const ServientregaMassiveMaxBatchSize = 10;

export const appsIncludedFromAllies = [
    "2264aec3-f39a-4658-98de-88919349249d",
    "b7f45d59-8adc-42f2-b5ee-cd13abd2b595",
    "26423c7a-f6cb-470c-b554-8c956e137cce"
]

export const statusReadOnlyVLD = ["VRF", "EMC", "RVK", "FIN", "RCB", "LGE"]

//Lista de tipos de certificado que no visualizan notificación de reenvío
export const typesWithoutForwardNotification = ["TK", "P12"]

export const validityLabelsAgreements = {
    A: ['Año', 'Años'],
    M: ['Mes', 'Meses'],
    D: ['Día', 'Días'],
    H: ['Hora', 'Horas']
};

export const tittleCredentialCertificate = "Credenciales de Certificado";
export const tittleCredentialSignature = "Credenciales de Firma";

export const blackListContractsFormAssign = [
    'ECDDIAN202511'
];

export const flagValidateDianProcessCf = true;

export const dianProductsForForm = [
    'RSAP10PFD',
    'RSAP10JFD'
];

export const statusIdRejectProcess = ["SOL", "RAD", "VLI","VRF","APV","APL","API","SUD"];


export const uploadImageSection = "Desliza un archivo .pdf, .jpg, .jpeg  aquí o"

/* 
Configuracion de Sesiones
Inicio
*/

//Configuración de tiempo de sesión
export const sessionTimeLabelFlag = false; //Bandera para mostrar el tiempo de sesión restante en la interfaz de usuario
export const sessionTimeClickFlag = false; //Bandera para permitir hacer clic en el tiempo de sesión restante
export const sessionTimeTitleFlag = false; //Bandera para mostrar el título "Sesión:" en el label de tiempo

// Configuración de inactividad
export const downtimeTagFlag = false; //Bandera para mostrar el tiempo de inactividad
export const downtimeTitleFlag = false; //Bandera para mostrar el título "Inactividad:" en el label de inactividad

//Configuracion de tiempo de duracion Alerta Toast
export const toastDuration = 2500; //Duracion de alerta (toast) en milisegundos de sesión extendida

export const inactivityConfiguration = {
    inactivityTimeout: 120, // Tiempo de inactividad en segundos para mostrar el modal
    inactivityModalTimeout: 60, // Tiempo en segundos para cerrar sesión después de mostrar el modal de inactividad
    mouseMoveCaptureTime: 3 // Tiempo en segundos para capturar el movimiento del mouse y resetear el timer de inactividad
}

export const sessionWarningConfiguration = {
    warningTime: 60 // Tiempo en segundos para mostrar la advertencia de sesión antes de que expire
}

/* 
Configuracion de Sesiones
Final
*/
export const presetCountryFormulary = "44";

export const arrayValidationConectors = ['de', 'del'];
